
import {
    Button,
    Grid,
    Paper
} from '@mui/material';
import { useContext } from 'react';
import { NavRoutes } from '../../../../contexts';
import { ResearchContext } from '../../ResearchContext';
import { LinkCreationDialog } from './LinkCreationDialog';
import { WidgetCreationDialog } from './WidgetCreationDialog';
import { XMLDialog } from './XMLDialog';

export const DeveloperBar = () => {

    const {

        isWidgetConfigurationPageOpen,
        setIsWidgetConfigurationPageOpen,

        isXMLPageOpen,
        setIsXMLPageOpen,

        isLinkCreationDialogOpen,
        setIsLinkCreationDialogOpen,

    } = useContext(ResearchContext);

    const handleCodeSubmit = () => {
        setIsWidgetConfigurationPageOpen(true);
    }
    const handleCloseCodeSubmit = () => {
        setIsWidgetConfigurationPageOpen(false);
    }
    const handleCloseLinkSubmit = () => {
        setIsLinkCreationDialogOpen(false);
    }

    const handleXMLSubmit = () => {
        setIsXMLPageOpen(true);
    }
    const handleCloseXMLSubmit = () => {
        setIsXMLPageOpen(false);
    }
    const handleAPISubmit = () => {
        window.open(`${NavRoutes.Api}`, '_blank');
    }
    const handleLinkSubmit = () => {
        setIsLinkCreationDialogOpen(true);
    }

    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    backgroundColor: 'rgba(0, 89, 179, 0.08)',
                    padding: 2,
                }}
            >
                <Grid
                    container
                    columnSpacing={2}
                    alignItems="center"
                    justifyContent="start"
                >

                    <Grid item>
                        <Button
                            variant='contained'
                            disableElevation
                            onClick={handleCodeSubmit}
                        >
                            Widget
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            disableElevation
                            onClick={handleXMLSubmit}
                        >
                            XML
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            disableElevation
                            onClick={handleAPISubmit}
                        >
                            API
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            disableElevation
                            onClick={handleLinkSubmit}
                        >
                            LINK
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            <WidgetCreationDialog
                isOpen={isWidgetConfigurationPageOpen}
                handleClose={handleCloseCodeSubmit}
            />
            <XMLDialog
                isOpen={isXMLPageOpen}
                handleClose={handleCloseXMLSubmit} />

            <LinkCreationDialog
                isOpen={isLinkCreationDialogOpen}
                handleClose={handleCloseLinkSubmit}
            />
        </>
    )
}